import { render, staticRenderFns } from "./GreyButton.vue?vue&type=template&id=01d39036&scoped=true"
import script from "./GreyButton.vue?vue&type=script&lang=ts"
export * from "./GreyButton.vue?vue&type=script&lang=ts"
import style0 from "./GreyButton.vue?vue&type=style&index=0&id=01d39036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d39036",
  null
  
)

export default component.exports